export default __webpack_public_path__ + "static/media/event-detail.edf17ab4.png";